export enum ModuleOnboardingErrors {
  OnboardingRunning = 0,
  SerialNumberNotSet = 1,
  NoCustomerModule = 2
}
